module.exports = __webpack_public_path__ + "908e4d2e/img/share-action-icon.9c12578c.svg";